document.querySelectorAll(".utility-secondary__item--object-authentication > a").forEach(function (el) {
	el.addEventListener("click", function (event) {
		event.preventDefault(); // Stop a normal link for now
		// Try to set a test cookie
		document.cookie = "is_cookies_enabled=1; path=/";
		// Check if the cookie was set successfully
		if (document.cookie.indexOf("is_cookies_enabled=") !== -1) {
			console.log("Cookies enabled.");
			// Navigate normally if cookies enabled
			window.location.href = el.href;
		} else {
			console.log("Cookies are disabled in this browser.");
			wdg_showCookiePopup();
		}
	});
});

function wdg_showCookiePopup() {
	// Remove last popup if it exists
	let lastPopup = document.querySelector(".cookie-popup");
	if (lastPopup) {
		lastPopup.remove();
	}

	// Add animation styles once
	if (!document.getElementById("cookie-popup-style")) {
		let style = document.createElement("style");
		style.id = "cookie-popup-style";
		style.textContent = `
		.cookie-popup{position:fixed;z-index:9999;display:flex;align-items:center;justify-content:center;gap:15px;height:100%;width:100%;background:#000000cc;top:0;left:0;padding:1rem}.cookie-popup__content{max-width:500px;background:#fff;text-align:center;border-radius:5px;position:relative;padding:1.5rem;display:flex;align-items:center;flex-wrap:wrap;justify-content:center;flex-direction:column}button.cookie-popup__close{position:absolute;right:15px;top:15px;border:1px solid #000;padding:0}.cookie-popup__content h3,.cookie-popup__content p{margin-top:10px}.cookie-popup__content h3:first-child{margin-top:0}.cookie-popup__btn-wrap{margin-top:1rem}.cookie-popup__btn-wrap button{padding:12px 25px;margin:0 auto;min-width:200px;justify-content:center}
		`;
		document.head.appendChild(style);
	}

	// Create popup
	let popup = document.createElement("div");
	popup.className = "cookie-popup";
	popup.innerHTML = `<div class="cookie-popup__content">
	<button class="cookie-popup__close"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle"
        viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
      </svg></button>
  <div>
    <h3>⚠️</h3>
    <h3>Cookies Disabled</h3>
    <p>Login functionality requires cookies to be enabled in your browser. Please enable cookies, then refresh the page and try again.</p>
  </div>
  <div class="cookie-popup__btn-wrap">
    <button type="button"onclick="window.open('https://support.google.com/accounts/answer/61416?hl=en','_blank','noopener,noreferrer')">Learn How to Enable Cookies</button></div></div>`;
	document.body.appendChild(popup);
	let closeBtn = popup.querySelector(".cookie-popup__close");
	// Close button handler
	closeBtn.addEventListener("click", () => {
		popup.classList.add("hide");
		setTimeout(() => popup.remove());
	});
	// Auto-hide after 3 seconds
	// setTimeout(() => {
	// 	if (document.body.contains(popup)) {
	// 		popup.classList.add("hide");
	// 		setTimeout(() => popup.remove(), 400);
	// 	}
	// }, 3000);
}
